import React from 'react';
import { Route, IndexRedirect } from 'react-router';

import CoreLayout from 'funnel/layouts/CoreLayout';

import FunnelQuestionsPage from 'funnel/pages/FunnelQuestionsPage';
import CreateQuestionPage from 'funnel/pages/CreateQuestionPage';
import AnswerPage from 'funnel/pages/AnswerPage';
import AdvicePage from 'funnel/pages/AdvicePage';
import FunnelScoringPage from 'funnel/pages/FunnelScoringPage';
import FunnelAdvicesPage from 'funnel/pages/FunnelAdvicesPage';
import FunnelProductsPage from 'funnel/pages/FunnelProductsPage';

export default (store, funnel) => (
  <Route path="/" component={CoreLayout} funnel={funnel}>
    <IndexRedirect to="/questions" />
    <Route path="questions" component={FunnelQuestionsPage} />
    <Route path="questions/new" component={CreateQuestionPage} />
    <Route path="questions/:question/answers/new" component={AnswerPage} />
    <Route path="answers/:id" component={AnswerPage} />
    <Route path="products" component={FunnelProductsPage} />
    <Route path="scoring" component={FunnelScoringPage} />
    <Route path="advices" component={FunnelAdvicesPage} />
    <Route path="advices/new" component={AdvicePage} />
    <Route path="advices/:id" component={AdvicePage} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/modules/funnel/routes/index.js